import {objets,imgObjt} from "../../datas/objets"
import stateImg from '../../assets/imgObjet/sun.svg'
import {useState,usee} from 'react'
import './objetCommandeView.css'
import Logoboard from './logoboard'
import commandeOn from '../../assets/imgObjet/commande/SwitchOn.png'
import commandeOff from '../../assets/imgObjet/commande/SwitchOff.png'
import { useSpring,animated } from "react-spring"

function ObjetCommandeView({dashOrView}){
    const [objetViewer,setObjetViewer] = useState(objets)
    const springProps = useSpring({
       from:{opacity: 1,
        transform:'scale(1)'},
        to: {
          // Propriétés de style animées lorsqu'isAnimated est vrai
          opacity: 0,
          transform:'scale(0.2)'
        }
      });
    const handeleSateObjet = (id) => {
        const newList = []
        objetViewer.map((s) => {
                if (s.idObjet === id){
                    s.state = !s.state
                }
                newList.push(s)
            })
        
        setObjetViewer(newList)
    }
    const deleteUnobjet = (idObjet) =>{
        const updatedList = objetViewer.map(item => {
            if (item.idObjet === idObjet) {  
              return null;
            }
            return item;
          });
          const filteredList = updatedList.filter(item => item !== null);
   
        setObjetViewer(filteredList)
       
    }
    const imgGenerate = (objt) => {
        switch (objt) {
            case 'ampoule':
                return imgObjt.ampoule
                break;
            case 'porte' :
                return imgObjt.porte
                break;
            case 'ventilo' :
                return imgObjt.ventilo
                break;
            case 'fenetre' :
                return imgObjt.fenetre
                break;
            default:
                return <b>No Component</b>
                break;
        }
    }
    return <div className="bg-objetCommandeView" >
        {dashOrView==='dash'? <Logoboard/>: null}
        {
                objetViewer.map(objet => 
                     <animated.div className="objet" key={objet.idObjet} >
                        <img src={objet.state ? imgGenerate(objet.Objet).on : imgGenerate(objet.Objet).off } alt={objet.nameObjet} />
                        <div className="detailObjet">
                        {dashOrView==='delete'? <button className="deleteObjet" onClick={()=> deleteUnobjet(objet.idObjet)}>Supprimer</button> : null}
                            <div>
                                <h4>{objet.nameObjet}</h4>
                                <p>{objet.Objet}</p>
                            </div>
                            {dashOrView==='dash'? <div className="viewState">
                                <p>{objet.state ? <img src={stateImg} alt="image sun" /> : null}</p>
                                <button className="buttonCommande" onClick={
                                    () => handeleSateObjet(objet.idObjet)}>{objet.state ? <img src={commandeOn} width={'20px'} alt=" commande on"  /> : 
                                    <img src={commandeOff} alt=" commande on" width={'20px'} />}</button>
                            </div> : <p>Pour {objet.categorie}</p>}
                        </div>
                    </animated.div>
                )
        }
        
    </div>
}

export default ObjetCommandeView